<template>
  <div style="width: 100%" class="main-container">
    <div class="readiness-container pt-8">
      <PageTitle
        class="page-title"
        title="Organizational Readiness"
        show_help_menu
        :counter_label="'Active'"
        :counter_count="sidebarCountStore.positions"
      />
      <div class="path-to-readiness-bar">
        <PathToReadinessBar
          :readiness="viewState.state.readiness.average_readiness"
          :showRecalculate="false"
          :readinessTitle="'Average Readiness'"
          :loading="readinessLoading"
        />
      </div>
    </div>
    <ReadinessOrganizationView />
  </div>
</template>

<script setup>
import { onMounted, getCurrentInstance, computed } from "vue";
import ReadinessOrganizationView from "@/views/ReadinessOrganization/ReadinessOrganizationView.vue";
import PageTitle from "@components/common/PageTitle.vue";
import { useViewState } from "./ReadinessOrganization/composables/useViewState";
import PathToReadinessBar from "@components/PathToReadinessBar/PathToReadinessBar.vue";
import { useSidebarCountStore } from "@/store/pinia/sidebarCount";

const app = getCurrentInstance();
const { proxy } = app;
const viewState = useViewState();
const sidebarCountStore = useSidebarCountStore();
const readinessLoading = computed(() => {
  return viewState.state.readiness.loading;
});
onMounted(async () => {
  proxy.$loader.show();
  await viewState.loadAccountDetails();
  proxy.$loader.hide();
});
</script>

<style scoped>
.main-container {
  padding-bottom: 60px;
}
.readiness-container {
  padding-left: 12px;
  width: 100%;
}
.path-to-readiness-bar {
  padding-top: 8px;
  margin-right: 12px;
}
</style>
